module.exports = __webpack_public_path__ + "img/taste-table6.081bd898.png";